import React, { useState, memo, useEffect, useCallback } from 'react';

import ScheduleForm from 'containers/Scheduling/RightDrawer/ScheduleForm';
import { initialScheduleFormData } from 'containers/Scheduling/RightDrawer/ScheduleForm/schema';
import { transformScheduleDataToFormData } from 'containers/Scheduling/shared/FilterGroup/transformScheduleDataToFormData';
import { useFetchScheduleById } from 'hooks/scheduling/useFetchScheduleById';

interface IDuplicateSchedulePopulatorProps {
  onClose: () => void;
  scheduleId: string | null;
  formData: typeof initialScheduleFormData;
}

const DuplicateSchedulePopulator: React.FC<IDuplicateSchedulePopulatorProps> = ({ onClose, scheduleId, formData }) => {
  const [scheduleFormData, setScheduleFormData] = useState<typeof initialScheduleFormData>(initialScheduleFormData);

  const { data, isLoading, isFetched } = useFetchScheduleById(scheduleId, {
    onSuccess: (data: any) => {
      setupScheduleFormData(data?.payload);
    },
  });

  const setupScheduleFormData = useCallback((fetchedData: any) => {
    const newFormData = transformScheduleDataToFormData(fetchedData);

    newFormData.id = '';
    newFormData.event_pid = '';
    newFormData.start_date = formData.start_date;
    newFormData.end_date = formData.end_date;
    newFormData.start_time = formData.start_time;
    newFormData.end_time = formData.end_time;
    newFormData.repeat_start_date = undefined;
    newFormData.repeat_end_date = undefined;
    newFormData.publish = false;
    newFormData.user_ids = [...newFormData.user_ids, ...formData.user_ids];

    setScheduleFormData(newFormData);
  }, []);

  useEffect(() => {
    if (isFetched && data) {
      setupScheduleFormData(data?.payload);
    }
  }, [isFetched, data, formData, setupScheduleFormData]);

  return <ScheduleForm formData={scheduleFormData} onClose={onClose} showLoader={isLoading} />;
};

export default memo(DuplicateSchedulePopulator);
